import * as React from "react";
const SvgFiRrInsight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-insight_svg__a)">
      <path
        fill="#062147"
        d="M17.994 2.286A9.05 9.05 0 0 0 10.956.06C6.905.517 3.591 3.782 3.075 7.822c-.374 2.932.644 5.76 2.792 7.76C7.243 16.862 8 18.484 8 20.15v.29C8 22.436 9.537 24 11.5 24h1c1.93 0 3.5-1.57 3.5-3.5v-.739c0-1.486.687-2.906 1.933-3.998a8.997 8.997 0 0 0 .061-13.477M12.5 22h-1c-.841 0-1.5-.685-1.5-1.56v-.29c0-.05-.007-.1-.008-.15H14v.5c0 .827-.673 1.5-1.5 1.5m4.114-7.74c-1.177 1.03-1.989 2.34-2.368 3.74H9.678c-.421-1.43-1.248-2.765-2.448-3.88-1.671-1.557-2.463-3.759-2.171-6.044.4-3.137 2.975-5.673 6.121-6.029q.417-.046.828-.047c1.725 0 3.353.617 4.652 1.778a6.991 6.991 0 0 1-.046 10.481M16 7.5v.871c-.598-.137-1.368-.27-1.6-.27a1.4 1.4 0 0 0 0 2.8c.232 0 1.002-.135 1.6-.272v.871a1.5 1.5 0 0 1-1.5 1.5h-4A1.5 1.5 0 0 1 9 11.5v-.65c-.401.094-.767.15-1 .15a1.5 1.5 0 0 1 0-3c.233 0 .599.056 1 .151v-.65A1.5 1.5 0 0 1 10.5 6h.671c-.091-.392-.145-.747-.145-.975a1.5 1.5 0 0 1 3 0c0 .228-.054.583-.146.974h.62A1.5 1.5 0 0 1 16 7.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-insight_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrInsight;
